import PropTypes from 'prop-types';
import cssVariables from '../../../../styles/variables';

/* eslint-disable max-len */
const HeartFullIcon = ({
  width,
  height,
  viewBox,
  onClick,
  className,
  dataTestId,
  fill,
}) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox || '0 0 19 17'}
    fill={fill || cssVariables['--tunein-coral']}
    className={className}
    data-testid={dataTestId}
    onClick={onClick}
  >
    <path
      d="M4.75 0a4.48 4.48 0 0 0-3.24 1.4 5.52 5.52 0 0 0 0 7.6l7.34 7.65a.51.51 0 0 0 .72 0L16.9 9a5.51 5.51 0 0 0 0-7.59 4.45 4.45 0 0 0-6.48 0L9.21 2.66 8 1.4A4.5 4.5 0 0 0 4.75 0"
      fillRule="evenodd"
    />
  </svg>
);

HeartFullIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  viewBox: PropTypes.string,
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  fill: PropTypes.string,
  onClick: PropTypes.func,
};

export default HeartFullIcon;
